import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
} from "@material-ui/core";
import { BUSINESS_INSURANCE } from "routes/paths";

const MyDialog = ({ open, closeDialog }) => {
  const [count, setCount] = useState(5);
  const history = useHistory();
  useEffect(() => {
    if (open) {
      const timer = count > 0 && setInterval(() => setCount(count - 1), 1000);
      return () => {
        clearInterval(timer);
      };
    }
  }, [count, open]);

  useEffect(() => {
    if (count === 0) {
      closeDialog();

      history.push(BUSINESS_INSURANCE);
      setCount(5);
    }
  }, [count, history]);
  return (
    <Dialog open={open}>
      <DialogTitle>IMPORTANT NOTE:</DialogTitle>
      <DialogContent>
        <DialogContentText>
          East West Insurance Brokerage Inc. is a non-life insurance brokerage
          arm which is a wholly-owned subsidiary of East West Banking
          Corporation (EastWest) duly regulated and supervised by the Insurance
          Commission. Products herein are not covered under the guarantee of
          PDIC nor by EastWest Bank.
          <h5>Redirecting in {count} seconds...</h5>
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
};

export default MyDialog;
